import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { configApiUrl } from "../constants/url-constants";

const BASE_API_URL = `${configApiUrl()}/api`;

export default createScopedApi(BASE_API_URL, axiosInstance);
